import React, { useState } from "react";
import { scenarioData } from "../modules/Scenarios/mockData";

export const CreateScenarioContext = React.createContext(null);

export function CreateScenarioProvider({ children }) {
  const [scenarioList, setScenarioList] = useState(scenarioData);
  const [createNewScenario, setCreateNewScenario] = useState({});
  return (
    <CreateScenarioContext.Provider
      value={{
        scenarioList,
        setScenarioList,
        setCreateNewScenario,
        createNewScenario,
      }}
    >
      {children}
    </CreateScenarioContext.Provider>
  );
}
